import React, { Component } from 'react';
import Card from './card';
import './resultBox.css';

class ResultBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            podcasts: props.podcasts,
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.podcasts !== prevProps.podcasts) {
            this.setState({
                podcasts: this.props.podcasts
            })
        }
    }

    render() {
        return (
            <div className="wrapper">
                <div className="resultsArea">
                    {this.state.podcasts !== undefined && this.state.podcasts.map(podcast => {
                        return (
                            <Card
                                key={podcast.id}
                                img={podcast.thumbnail}
                                publisher={podcast.podcast.publisher_original}
                                title={podcast.podcast.title_original}
                                description={podcast.description_original}
                                link={podcast.link}
                                audio_link={podcast.audio}>
                            </Card>
                        )
                    })}
                </div>
            </div >
        );
    }
}

export default ResultBox;